import { render, staticRenderFns } from "./LmImagen.vue?vue&type=template&id=680dc24d&"
import script from "./LmImagen.vue?vue&type=script&lang=js&"
export * from "./LmImagen.vue?vue&type=script&lang=js&"
import style0 from "./LmImagen.vue?vue&type=style&index=0&id=680dc24d&prod&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports